import { render, staticRenderFns } from "./CustomerSources.vue?vue&type=template&id=680a1ea6&scoped=true"
import script from "./CustomerSources.vue?vue&type=script&lang=js"
export * from "./CustomerSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680a1ea6",
  null
  
)

export default component.exports